import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

function abs(url) {
    if (!url) return null;
    if (url.startsWith("http")) return url;
    return `${BACKEND_URL}${url}`;
}

export function usePhotos() {
    const [data, setData] = useState({
        hero: null,
        about: null,
        packages: {},
        gallery: [],
        loaded: false,
    });
    useEffect(() => {
        api.get("/photos")
            .then((r) => {
                setData({
                    hero: abs(r.data.hero),
                    about: abs(r.data.about),
                    packages: Object.fromEntries(
                        Object.entries(r.data.packages || {}).map(([k, v]) => [
                            k,
                            abs(v),
                        ]),
                    ),
                    gallery: (r.data.gallery || []).map((g) => ({
                        ...g,
                        url: abs(g.url),
                    })),
                    loaded: true,
                });
            })
            .catch(() => setData((d) => ({ ...d, loaded: true })));
    }, []);
    return data;
}

export const absUrl = abs;
